<template>
  <div>
    <el-button
      type="primary"
      size="mini"
      @click="openDialog"
    >
      Manage Users
    </el-button>
    <el-dialog
      :visible.sync="dialog_visible"
      title="Manage Users and Team Leader"
      width="520px"
      @close="close_dialog"
      @opened="set_default_input()"
    >
      <el-form
        ref="form"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="Select List">
          <el-select
            v-model="selected_list"
            placeholder="Select task list"
            filterable
            clearable
            style="width: 100%"
            @change="fetch_jobs_lists"
          >
            <el-option
              v-for="list in lists"
              :key="list.id"
              :label="list.name"
              :value="list.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Assigned Users">
          <div class="assigned-user-badges">
            <el-tag
              v-for="user in assigned_users"
              :key="user.id"
              type="info"
              size="mini"
              closable
              style="margin: 4px"
              @close="delete_user_from_list(user.id)"
            >
              {{ user.name }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item
          label="Suggested Users"
          size="mini"
        >
          <el-select
            v-model="selected_suggested_users"
            placeholder="Select suggested users"
            filterable
            multiple
            collapse-tags
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="user in suggested_users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="assign_users"
          >
            Assign Selected Users
          </el-button>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="mini"
          @click="dialog_visible = false"
        >Cancel</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="handle_ok"
        >OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {set_default_input} from '../../utilities/DefaultInput';
export default {
  name: 'ManageUsers',
  props: {
    proposal_id: {
      type: [Number, String],
      required: true
    },
  },
  data() {
    return {
      dialog_visible: false,
      lists: []
    };
  },
  mounted() {
    this.fetch_jobs_lists();
  },
  methods: {
    set_default_input,
    fetch_jobs_lists() {
      this.$http
        .get(`/api/job_lists/job_lists_by_proposal?proposal_id=${this.proposal_id}`)
        .then((response) => {
          this.lists = response.data;
        });
    },
    get_users() {
      this.$http
        .get(`/api/job_lists/job_lists_by_proposal?proposal_id=${this.proposal_id}`)
        .then((response) => {
          this.lists = response.data;
          this.get_users_by_list();
        });
    },

    openDialog() {
      this.dialog_visible = true;
    },
    close_dialog() {
      this.dialog_visible = false;
    },
  },
};
</script>

<style scoped>

</style>
